<template>
  <div class="">

    <template v-if="residences == null"></template>

    <template v-else>

      <template v-if="residences != null && residences.length > 0">

        <template v-if="!isPrimaryApplicant">
          <div class="my-6">
            <a href="#" 
              class="no-underline text-white bg-blue-500 hover:bg-blue-600 p-2 font-semiboldtext-xs"
              @click.prevent="copyFromPrimary()">Copy all addresses from the primary applicant</a>
          </div>
        </template>

        <template v-for="(residence, index) in residences">
          <template v-if="index == 0">
            <div class="text-2xl mt-6 font-thin">Current address</div>
          </template>

          <template v-else-if="index == 1">
            <div class="text-2xl mt-6 font-thin">Previous address</div>
            <div class="mt-2 mb-6 text-base mt-1 mb-4" v-if="index == 1 && isCurrentLessThanThreeYears()">
              * Required since you have only been at your current address for less than 3 years
            </div>
          </template>

          <div class="mt-6">
            <Residence
              :index="index"
              :residence="residence"
              :updateValue="updateValue"
              :moveToPrevious="moveToPrevious"
              :deleteAddress="deleteAddress"
              :numAddresses="residences.length"
              :isCurrentLessThanThreeYears="isCurrentLessThanThreeYears"></Residence>
          </div>
        </template>

        <div class="mt-4">
          <a href="#" 
            @click.prevent="addPreviousAddress()" 
            class="bg-green-500 inline-block hover:bg-green-600 py-2 px-4 text-white font-semibold uppercase no-underline">
            + Add previous address
          </a>
        </div>
      </template>

      <div class="button-line">
        <ApplicationButton />
      </div>
    </template>
  </div>
</template>

<script>
  import axios              from 'axios'
  import moment             from 'moment'
  import InputText          from '@/shared/components/form/InputText'
  import { EventBus }       from '@/shared/event-bus'
  import Residence          from './Residence'
  import ApplicationButton  from '@/shared/components/form/ApplicationButton'
  
  
  export default {

    components: {
      InputText,
      Residence,
      ApplicationButton
    },

    data() {
      return {
        residences : null,
        currAddress: null
      }
    },

    created() {
      this.getData()
    },

    watch : {
      '$route' (to, from) {
        this.getData()
      },

      'currAddress.moved_in_at' : function(newValue, oldValue) {
        let addPreviousAddress = false
        
        if(newValue != null) {
          if(this.isCurrentLessThanThreeYears()) {
            addPreviousAddress = true
          }
        }

        // only add previous address if there is no other previous currently
        if(this.residences.length > 1) {
          addPreviousAddress = false
        }

        if(addPreviousAddress) {
          this.addPreviousAddress()
        }
      }
    },

    methods : {

      // if the current residence is under 3 years, then we need to add a new previous address
      isCurrentLessThanThreeYears() {
        if(this.residences[0].moved_in_at == null) {
          return true
        }
        
        if(this.residences[0] != null && this.residences[0].moved_in_at != null) {
          let now    = moment()
          let then   = moment(this.residences[0].moved_in_at, "YYYY-MM-DD")
          let months = now.diff(then, 'months')
          console.log(months)
          return months < 36
        }
        
        return false
      },

      getData() {
        this.showLoader("Loading addresses...")
        this.apiGet({
          clientId   : this.$route.params.clientId,
          applicantId: this.$route.params.applicantId          
        }, 'address/residences', (residences) => {
          this.hideLoader()
          this.residences  = residences
          this.currAddress = this.residences[0]
        })
      },

      // a method that will receive the value and update
      updateValue(params) {
        if(params.objectType == 'address') {
          this.updateAddress(this.residences[params.index].address, params.key, params.value)
        }

        else if(params.objectType == 'residence') {
          this.updateResidence(this.residences[params.index], params.key, params.value) 

          // check if it's moved in date, then we can update the previous address
          if(params.key == 'moved_in_at' && params.value != null && this.residences[params.index + 1] != null && this.residences[params.index + 1].moved_out_at == null) {

            // this is some crazy update.....
            let priorDate = moment(params.value, "YYYY-MM-DD").add(-1, 'days')
            this.updateResidence(this.residences[params.index + 1], 'moved_out_at', priorDate.format("YYYY-MM-DD"))
            document.getElementById(params.objectType + "moved_out_at" + (params.index + 1)).value = priorDate.format("D/M/YYYY")
          }
        }
      },

      deleteAddress(addressId, addressIndex) {
        this.$modal.show('confirm-modal', {
          // width : 600,
          title  : "Please confirm your action",
          message: "Are you sure you want to delete this?",
          buttons:[{
            label          : 'Yes',
            color          : 'red',
            loadingViaLocal: true, // a bit of HACK, we want to show loading image when button is clicked, but hard to pass loading prop to a modal
            action         : () => {
              this.apiDelete({
                clientId   : this.$store.state[this.$store.state.view + 'Module'].client.id,
                applicantId: this.$route.params.applicantId,
                addressId  : addressId
              }, 'address/delete', () => {
                this.$modal.hide('confirm-modal')
                this.residences.splice(addressIndex, 1)
                EventBus.$emit('notification-event', {
                  'type'   : 'success',
                  'message': "Address deleted successfully"
                });
              })
            }
          }, {
            label : 'No',
            color : 'gray',
            action: () => {
              this.$modal.hide('confirm-modal')
            }
          }]
        })
      },

      moveToPrevious(addressId) {
        this.showLoader("Moving to previous...")
        this.apiPost({
          clientId   : this.$route.params.clientId,
          applicantId: this.$route.params.applicantId,
          addressId
        }, 'address/move-current-to-previous', () => {
          EventBus.$emit('set-autosave', false)
          this.getData()          
        })
      },

      copyFromPrimary() {
        this.showLoader("Copying from primary...")
        
        axios.post(process.env.VUE_APP_API_URL + '/api/address/copy-from-primary', {
          clientId   : this.$route.params.clientId,
          applicantId: this.$route.params.applicantId
        }, {
          headers: {
            'Authorization' : 'Bearer ' + localStorage.getItem('bp-broker-jwt')
          }
        }).then(response => {
          EventBus.$emit('set-autosave', false)
          this.getData()
        }).catch(e => {
          this.hideLoader()
          EventBus.$emit('set-autosave', false)
        })
      },

      // submit for this should save everything for the final time
      // and then take the user to the next tab, which is assets
      submit() {

        // take the user to an appropriate page depending on whether it's client or broker
        if(this.$store.state.view == 'broker') {
          this.$router.push({ 
            name : 'application-applicant-employment'
          })
        } else {
          this.$router.push({ 
            name : 'client-applicant-employment'
          })
        }
      },

      addPreviousAddress() {
        this.showLoader("Adding an address...")
        this.apiPost({
          clientId   : this.$route.params.clientId,
          applicantId: this.$route.params.applicantId,          
        }, 'address/create', () => {
          this.hideLoader()
          this.getData()          
        })
      },
    }
  }
</script>